export var simpleEmailValidation = function (value) {
    return /^[a-zA-Z0-9.'!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value);
};
//# sourceMappingURL=simpleEmailValidation.js.map